// extracted by mini-css-extract-plugin
export default {"scanner":"SpinnerLg_scanner__DkOA8","load91371":"SpinnerLg_load91371__HqD15"};